// Missfit theme JS — porteret 1:1 fra missfit-web/public/js/site.js
// med Shopify-tilpasninger: rigtig add-to-cart i pakkebygger og produktform-sync.
(function () {
  // Blød inerti-scroll på desktop — respekterer "reduceret bevægelse" og rører ikke mobil.
  if (
    window.Lenis &&
    window.matchMedia("(prefers-reduced-motion: no-preference)").matches &&
    window.matchMedia("(pointer: fine)").matches
  ) {
    var lenis = new window.Lenis({ duration: 1.05, smoothWheel: true });
    var lenisRaf = function (tid) { lenis.raf(tid); requestAnimationFrame(lenisRaf); };
    requestAnimationFrame(lenisRaf);
    // Kurv-drawerens liste skal kunne scrolle uafhængigt
    document.querySelectorAll("[data-kurv-linjer], cart-drawer, .drawer__inner, cart-notification").forEach(function (el) {
      el.setAttribute("data-lenis-prevent", "");
    });
  }

  // Scroll-reveal: [data-reveal] -> .is-visible.
  // Indholdet er synligt uden JS (ingen blank side på langsomt net) — html.mf-js
  // aktiverer skjulningen, og elementer i viewporten markeres synlige i SAMME
  // frame med en intro-fade, så intet blinker.
  if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    document.documentElement.classList.add("mf-js");
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add("is-visible", "is-intro");
      } else {
        io.observe(el);
      }
    });
  } else {
    document.querySelectorAll("[data-reveal]").forEach(function (el) { el.classList.add("is-visible"); });
  }

  // Hero-video: spil kun et udsnit af klippet i loop (data-video-start/-end).
  document.querySelectorAll("video[data-video-start]").forEach(function (video) {
    var start = parseFloat(video.getAttribute("data-video-start"));
    var slut = parseFloat(video.getAttribute("data-video-end")) || 0;
    if (!start) return;
    var afspil = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    var hold = function () {
      if (video.readyState < 1) return;
      var t = video.currentTime;
      if (t < start - 0.5 || (slut && t >= slut)) {
        try { video.currentTime = start; afspil(); } catch (e) {}
      }
    };
    video.addEventListener("loadedmetadata", hold);
    video.addEventListener("seeked", afspil);
    video.addEventListener("timeupdate", hold);
    hold();

    // Pausér videoen når den er ude af viewport — sparer dekodning under scroll
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) afspil();
          else video.pause();
        });
      }, { threshold: 0.05 }).observe(video);
    }
  });

  // Count-up: [data-countup] tæller op til slutværdien, når tallet bliver synligt
  var countups = document.querySelectorAll("[data-countup]");
  if (countups.length) {
    var reducedMotion = !window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
    var startCount = function (el) {
      var slut = parseFloat(el.getAttribute("data-countup"));
      if (reducedMotion) { el.textContent = slut; return; }
      var start = null;
      var tick = function (ts) {
        if (!start) start = ts;
        var t = Math.min((ts - start) / 1100, 1);
        el.textContent = Math.round(slut * (1 - Math.pow(1 - t, 3)));
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if ("IntersectionObserver" in window && !reducedMotion) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { startCount(entry.target); cio.unobserve(entry.target); }
        });
      }, { threshold: 0.6 });
      countups.forEach(function (el) { cio.observe(el); });
    } else {
      countups.forEach(startCount);
    }
  }

  // Announcement-bar: rotér beskederne
  document.querySelectorAll("[data-announcements]").forEach(function (bar) {
    var beskeder = bar.querySelectorAll("span");
    if (beskeder.length < 2 || !window.matchMedia("(prefers-reduced-motion: no-preference)").matches) return;
    var aktiv = 0;
    setInterval(function () {
      beskeder[aktiv].classList.remove("is-active");
      aktiv = (aktiv + 1) % beskeder.length;
      beskeder[aktiv].classList.add("is-active");
    }, 4200);
  });

  // Vandrette scrollerækker: [data-scroller] med prev/next-knapper.
  // Ægte uendeligt loop: klonerne er server-renderet (andet halve sæt af rækken),
  // og rækken teleporterer usynligt tilbage, når man passerer skillelinjen.
  document.querySelectorAll("[data-scroller]").forEach(function (sektion) {
    var row = sektion.querySelector("[data-scroller-row]");
    var prev = sektion.querySelector("[data-scroll-prev]");
    var next = sektion.querySelector("[data-scroll-next]");
    if (!row || !prev || !next || row.children.length < 4) return;

    var antal = row.children.length / 2;
    var setBredde = function () { return row.children[antal].offsetLeft - row.children[0].offsetLeft; };
    var step = function () {
      var kort = row.firstElementChild;
      return kort ? kort.getBoundingClientRect().width + 18 : row.clientWidth * 0.8;
    };
    var normaliser = function () {
      var w = setBredde();
      if (w > 0 && row.scrollLeft >= w) row.scrollLeft -= w;
    };
    var timer;
    row.addEventListener("scroll", function () {
      clearTimeout(timer);
      timer = setTimeout(normaliser, 120);
    }, { passive: true });

    next.addEventListener("click", function () {
      row.scrollBy({ left: step(), behavior: "smooth" });
    });
    prev.addEventListener("click", function () {
      if (row.scrollLeft < step()) row.scrollLeft += setBredde();
      row.scrollBy({ left: -step(), behavior: "smooth" });
    });
  });

  // Side-kurv (drawer): åbnes fra headerens kurv-ikon og efter add-to-cart.
  // Indholdet genopbygges fra /cart.js; ændringer går via /cart/change.js.
  var kurvRod = document.querySelector("[data-kurv]");
  if (kurvRod) {
    var kurvLinjer = kurvRod.querySelector("[data-kurv-linjer]");
    var kurvBund = kurvRod.querySelector("[data-kurv-bund]");
    var kurvTotal = kurvRod.querySelector("[data-kurv-total]");
    var kurvTitelAntal = kurvRod.querySelector("[data-kurv-titel-antal]");
    var kurvFragt = kurvRod.querySelector("[data-kurv-fragt]");
    var fragtGraense = parseInt(kurvRod.getAttribute("data-fragtgraense") || "0", 10) * 100;
    var kurvTravl = false;

    var formatKr = function (oere) {
      return (oere / 100).toLocaleString("da-DK", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " kr";
    };

    var opdaterBadge = function (antal) {
      document.querySelectorAll(".header__kurvtal").forEach(function (tal) {
        tal.textContent = antal;
        tal.hidden = antal === 0;
      });
    };

    var kurvUpsell = kurvRod.querySelector("[data-kurv-upsell]");

    var opdaterUpsell = function (data) {
      if (!kurvUpsell) return;
      var iKurven = data.items.map(function (vare) { return vare.product_id; });
      var synlige = 0;
      kurvUpsell.querySelectorAll("[data-upsell-produkt]").forEach(function (kort) {
        var vis = iKurven.indexOf(parseInt(kort.getAttribute("data-produkt-id"), 10)) === -1;
        kort.style.display = vis ? "" : "none";
        if (vis) synlige++;
      });
      kurvUpsell.hidden = data.item_count === 0 || synlige === 0;
    };

    var renderKurv = function (data) {
      opdaterUpsell(data);
      opdaterBadge(data.item_count);
      if (kurvTitelAntal) kurvTitelAntal.textContent = "(" + data.item_count + ")";
      if (kurvTotal) kurvTotal.textContent = formatKr(data.total_price);
      if (kurvBund) kurvBund.hidden = data.item_count === 0;

      if (kurvFragt) {
        if (fragtGraense && data.item_count > 0) {
          var fri = data.total_price >= fragtGraense;
          kurvFragt.textContent = fri
            ? "Du har fri fragt ✓"
            : "Fri fragt ved " + formatKr(fragtGraense) + " — mangler " + formatKr(fragtGraense - data.total_price);
          kurvFragt.classList.toggle("er-fri", fri);
          kurvFragt.hidden = false;
        } else {
          kurvFragt.hidden = true;
        }
      }

      if (data.item_count === 0) {
        kurvLinjer.innerHTML =
          '<div class="kurv__tom"><p>Din kurv er tom.</p>' +
          '<a class="btn btn--primary" href="/collections/all">Shop udstyret</a></div>';
        return;
      }

      var html = "";
      data.items.forEach(function (vare, i) {
        var linje = i + 1;
        var billedeUrl = vare.image
          ? vare.image + (vare.image.indexOf("?") > -1 ? "&" : "?") + "width=160"
          : "";
        var billede = billedeUrl
          ? '<img class="kurv__billede" src="' + billedeUrl + '" alt="" loading="lazy">'
          : '<span class="kurv__billede"></span>';
        var variant = vare.variant_title && vare.variant_title !== "Default Title"
          ? '<span class="kurv__variant">' + vare.variant_title + "</span>"
          : "";
        html +=
          '<div class="kurv__linje">' + billede +
          '<div class="kurv__info"><b>' + vare.product_title + "</b>" + variant +
          '<div class="kurv__raekke"><span class="pkort__vaelger kurv__antal">' +
          '<button type="button" data-kurv-minus data-linje="' + linje + '" aria-label="Færre">&minus;</button>' +
          "<span>" + vare.quantity + "</span>" +
          '<button type="button" data-kurv-plus data-linje="' + linje + '" aria-label="Flere">+</button>' +
          '</span><b class="kurv__pris">' + formatKr(vare.final_line_price) + "</b></div></div>" +
          '<button type="button" class="kurv__fjern" data-kurv-fjern data-linje="' + linje + '" aria-label="Fjern">&times;</button>' +
          "</div>";
      });
      kurvLinjer.innerHTML = html;
    };

    var aabnKurv = function () {
      kurvRod.hidden = false;
      // setTimeout frem for rAF: skal også fyre i baggrunds-/skjulte faner
      setTimeout(function () { kurvRod.classList.add("er-aaben"); }, 20);
      document.body.style.overflow = "hidden";
    };

    var lukKurv = function () {
      kurvRod.classList.remove("er-aaben");
      document.body.style.overflow = "";
      setTimeout(function () { kurvRod.hidden = true; }, 300);
    };

    var hentKurv = function () {
      return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderKurv);
    };

    var visKurv = function () { hentKurv().then(aabnKurv); };
    window.missfitKurv = { vis: visKurv };

    document.querySelectorAll("[data-kurv-aaben]").forEach(function (knap) {
      knap.addEventListener("click", function (e) {
        e.preventDefault();
        visKurv();
      });
    });

    kurvRod.querySelectorAll("[data-kurv-luk]").forEach(function (el) {
      el.addEventListener("click", lukKurv);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !kurvRod.hidden) lukKurv();
    });

    // Antal/fjern i draweren (delegeret — linjerne genopbygges løbende)
    kurvLinjer.addEventListener("click", function (e) {
      if (kurvTravl) return;
      var knap = e.target.closest("[data-kurv-plus], [data-kurv-minus], [data-kurv-fjern]");
      if (!knap) return;
      var linje = parseInt(knap.getAttribute("data-linje"), 10);
      var antalEl = knap.parentElement.querySelector("span");
      var nuvaerende = antalEl ? parseInt(antalEl.textContent, 10) : 1;
      var nyt;
      if (knap.hasAttribute("data-kurv-fjern")) nyt = 0;
      else if (knap.hasAttribute("data-kurv-plus")) nyt = nuvaerende + 1;
      else nyt = Math.max(0, nuvaerende - 1);
      kurvTravl = true;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: linje, quantity: nyt }),
      })
        .then(function (r) { return r.json(); })
        .then(renderKurv)
        .finally(function () { kurvTravl = false; });
    });

    // Upsell i draweren: "Tilføj +" lægger varen i kurven med ét klik
    if (kurvUpsell) {
      kurvUpsell.addEventListener("click", function (e) {
        var knap = e.target.closest("[data-upsell-tilfoej]");
        if (!knap || kurvTravl) return;
        var kort = knap.closest("[data-upsell-produkt]");
        var variantId = parseInt(kort.getAttribute("data-variant-id"), 10);
        if (!variantId) return;
        kurvTravl = true;
        knap.disabled = true;
        knap.textContent = "Tilføjer …";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (r) { if (!r.ok) throw new Error(); })
          .then(hentKurv)
          .catch(function () { knap.textContent = "Prøv igen"; })
          .finally(function () {
            kurvTravl = false;
            knap.disabled = false;
            knap.textContent = "Tilføj +";
          });
      });
    }

    // Produktsidens form: AJAX add-to-cart -> åbn draweren i stedet for redirect
    document.querySelectorAll('[data-produkt] form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var knap = form.querySelector("[data-kurv-knap]");
        var tekst = knap ? knap.textContent : "";
        if (knap) { knap.disabled = true; knap.textContent = "Lægger i kurven …"; }
        fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(visKurv)
          .then(function () { if (knap) { knap.disabled = false; knap.textContent = tekst; } })
          .catch(function () {
            if (knap) { knap.disabled = false; knap.textContent = "Noget gik galt — prøv igen"; }
          });
      });
    });
  }

  // Startpakke-bygger: antal pr. produkt, total, fri fragt — og RIGTIG add-to-cart.
  document.querySelectorAll("[data-pakke]").forEach(function (sektion) {
    var graense = parseInt(sektion.getAttribute("data-fragtgraense") || "0", 10);
    var bar = sektion.querySelector("[data-pakke-bar]");
    var antalUd = sektion.querySelector("[data-pakke-antal]");
    var totalUd = sektion.querySelector("[data-pakke-total]");
    var fragtUd = sektion.querySelector("[data-pakke-fragt]");
    var kurvKnap = sektion.querySelector("[data-pakke-kurv]");
    var produkter = sektion.querySelectorAll("[data-pakke-produkt]");

    var opdater = function () {
      var antal = 0, total = 0;
      produkter.forEach(function (p) {
        var n = parseInt(p.querySelector("[data-antal]").textContent, 10);
        antal += n;
        total += n * parseInt(p.getAttribute("data-pris"), 10);
        p.classList.toggle("har-antal", n > 0);
        p.querySelector("[data-antal-minus]").disabled = n === 0;
      });
      antalUd.textContent = antal;
      totalUd.textContent = total.toLocaleString("da-DK");
      if (graense) {
        var fri = total >= graense;
        fragtUd.textContent = fri ? "Fri fragt ✓" : "Fri fragt ved " + graense.toLocaleString("da-DK") + " kr — mangler " + (graense - total).toLocaleString("da-DK") + " kr";
        fragtUd.classList.toggle("er-fri", fri);
      }
      bar.hidden = antal === 0;
    };

    produkter.forEach(function (p) {
      var ud = p.querySelector("[data-antal]");
      p.querySelector("[data-antal-plus]").addEventListener("click", function () {
        ud.textContent = parseInt(ud.textContent, 10) + 1; opdater();
      });
      p.querySelector("[data-antal-minus]").addEventListener("click", function () {
        ud.textContent = Math.max(0, parseInt(ud.textContent, 10) - 1); opdater();
      });
    });

    if (kurvKnap) {
      kurvKnap.addEventListener("click", function () {
        // Saml varelinjer med rigtige variant-id'er
        var items = [];
        produkter.forEach(function (p) {
          var n = parseInt(p.querySelector("[data-antal]").textContent, 10);
          var id = parseInt(p.getAttribute("data-variant-id") || "0", 10);
          if (n > 0 && id) items.push({ id: id, quantity: n });
        });
        if (!items.length) {
          kurvKnap.textContent = "Vælg udstyr først";
          return;
        }
        kurvKnap.disabled = true;
        kurvKnap.textContent = "Lægger i kurven …";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function () {
            kurvKnap.disabled = false;
            kurvKnap.textContent = "Læg pakken i kurven";
            if (window.missfitKurv) window.missfitKurv.vis();
            else window.location.href = "/cart";
          })
          .catch(function () {
            kurvKnap.disabled = false;
            kurvKnap.textContent = "Noget gik galt — prøv igen";
          });
      });
    }
  });

  // Produktside: galleri, variant-pills (sync til skjult id-felt), antal (sync til quantity-felt)
  document.querySelectorAll("[data-produkt]").forEach(function (side) {
    var hoved = side.querySelector("[data-galleri-hoved]");
    side.querySelectorAll("[data-galleri-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        hoved.src = thumb.getAttribute("data-galleri-thumb");
        side.querySelectorAll("[data-galleri-thumb]").forEach(function (t) { t.classList.remove("er-valgt"); });
        thumb.classList.add("er-valgt");
      });
    });

    var idFelt = side.querySelector('input[name="id"]');
    side.querySelectorAll("[data-variant]").forEach(function (pill) {
      pill.addEventListener("click", function () {
        side.querySelectorAll("[data-variant]").forEach(function (p) { p.classList.remove("er-valgt"); });
        pill.classList.add("er-valgt");
        var vid = pill.getAttribute("data-variant-id");
        if (idFelt && vid) idFelt.value = vid;
      });
    });

    var antalUd = side.querySelector("[data-antal]");
    var minus = side.querySelector("[data-antal-minus]");
    var antalFelt = side.querySelector('input[name="quantity"]');
    if (antalUd && minus) {
      var opdaterAntal = function () {
        var n = parseInt(antalUd.textContent, 10);
        minus.disabled = n <= 1;
        if (antalFelt) antalFelt.value = n;
      };
      side.querySelector("[data-antal-plus]").addEventListener("click", function () {
        antalUd.textContent = parseInt(antalUd.textContent, 10) + 1; opdaterAntal();
      });
      minus.addEventListener("click", function () {
        antalUd.textContent = Math.max(1, parseInt(antalUd.textContent, 10) - 1); opdaterAntal();
      });
      opdaterAntal();
    }
  });

  // Mobilmenu: åbn/luk drawer, lås baggrundsscroll
  (function () {
    var menu = document.querySelector("[data-mobilmenu]");
    var aabnKnap = document.querySelector("[data-menu-aabn]");
    if (!menu || !aabnKnap) return;
    var aabn = function () {
      menu.hidden = false;
      document.body.style.overflow = "hidden";
      aabnKnap.setAttribute("aria-expanded", "true");
      var luk = menu.querySelector(".mobilmenu__luk");
      if (luk) luk.focus();
    };
    var luk = function () {
      menu.hidden = true;
      document.body.style.overflow = "";
      aabnKnap.setAttribute("aria-expanded", "false");
    };
    aabnKnap.addEventListener("click", aabn);
    menu.querySelectorAll("[data-menu-luk]").forEach(function (el) {
      el.addEventListener("click", luk);
    });
    menu.querySelectorAll("a[href]").forEach(function (a) {
      a.addEventListener("click", luk);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !menu.hidden) luk();
    });
  })();

  // Kontaktboble: vises efter lidt tid/scroll, luk huskes i sessionStorage
  document.querySelectorAll("[data-boble]").forEach(function (boble) {
    var noegle = "missfit-boble-lukket";
    try { if (sessionStorage.getItem(noegle)) return; } catch (e) {}
    var vist = false;
    var vis = function () {
      if (vist) return;
      vist = true;
      boble.hidden = false;
      window.removeEventListener("scroll", paaScroll);
    };
    var paaScroll = function () { if (window.scrollY > 400) vis(); };
    window.addEventListener("scroll", paaScroll, { passive: true });
    setTimeout(vis, parseInt(boble.getAttribute("data-forsinkelse") || "6000", 10));

    boble.querySelector("[data-boble-luk]").addEventListener("click", function () {
      boble.hidden = true;
      try { sessionStorage.setItem(noegle, "1"); } catch (e) {}
    });

    var bar = document.querySelector("[data-pakke-bar]");
    if (bar) {
      var vig = function () {
        boble.classList.toggle("boble--hoej", !bar.hidden);
      };
      new MutationObserver(vig).observe(bar, { attributes: true, attributeFilter: ["hidden"] });
      vig();
    }
  });

  // Mega-menu: kategori-tabs skifter mellem panelerne (Udstyr/Kosttilskud/Accessories)
  document.querySelectorAll("[data-mega-tabs]").forEach(function (rod) {
    var tabs = rod.querySelectorAll("[data-mega-tab]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var navn = tab.getAttribute("data-mega-tab");
        tabs.forEach(function (t) { t.classList.toggle("er-aktiv", t === tab); });
        rod.querySelectorAll("[data-mega-panel]").forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-mega-panel") !== navn;
        });
      });
    });
  });

  // Øvelses-popup: [data-ovelse] åbner sin <dialog data-ovelse-dialog>
  document.querySelectorAll("[data-ovelse]").forEach(function (knap) {
    var navn = knap.getAttribute("data-ovelse");
    var dialog = document.querySelector('[data-ovelse-dialog="' + navn + '"]');
    if (!dialog) return;
    knap.addEventListener("click", function () {
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute("open", "");
      // Flyt auto-fokus fra luk-knappen til selve dialogen — ingen fokus-ring ved åbning
      dialog.setAttribute("tabindex", "-1");
      dialog.focus({ preventScroll: true });
    });
    var luk = function () { if (dialog.close) dialog.close(); else dialog.removeAttribute("open"); };
    var lukKnap = dialog.querySelector("[data-luk]");
    if (lukKnap) lukKnap.addEventListener("click", luk);
    dialog.addEventListener("click", function (e) {
      if (e.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      var udenfor = e.clientY < r.top || e.clientY > r.bottom || e.clientX < r.left || e.clientX > r.right;
      if (udenfor) luk();
    });
  });
})();
